import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { MiniChips } from "@website/ui/mini-chips";
import { isFilled } from "@website/utils/is-filled";
import { numberConvert } from "@website/utils/number-convert";
export type AccommodationCardRatingProperties = {
  rating?: number;
  reviewCount?: number;
  showNewBadge?: boolean;
  newBadgeReviewLimit?: number;
};
export const AccommodationCardRating: React.FC<AccommodationCardRatingProperties> = t0 => {
  const $ = _c(15);
  const {
    rating,
    reviewCount,
    newBadgeReviewLimit: t1,
    showNewBadge: t2
  } = t0;
  const newBadgeReviewLimit = t1 === undefined ? 1 : t1;
  const showNewBadge = t2 === undefined ? true : t2;
  const isNew = isFilled(reviewCount) && reviewCount < newBadgeReviewLimit;
  const showRating = rating && rating > 0;
  if (showNewBadge && reviewCount !== undefined && isNew) {
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <MiniChips color="secondary" textClassName="!text-extra-caption !font-bold " className="" size="medium" text={"\u062C\u062F\u06CC\u062F"} variant="accent" />;
      $[0] = t3;
    } else {
      t3 = $[0];
    }
    return t3;
  }
  const t3 = `${showRating ? "visible" : "invisible"} flex items-center justify-end gap-1`;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      direction: "ltr"
    };
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <MaterialIcon name="star" variant="round" className="text-[18px]" />;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== rating) {
    t6 = numberConvert(rating, {
      locale: "fa"
    });
    $[3] = rating;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t6) {
    t7 = <div className="flex items-center justify-end gap-1">{t5}<span className="text-extra-caption text-on-surface-high-emphasis font-bold">{t6}</span></div>;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== reviewCount) {
    t8 = numberConvert(reviewCount, {
      locale: "fa"
    });
    $[7] = reviewCount;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t8) {
    t9 = <span className="text-extra-caption text-on-surface-medium-emphasis">({t8})</span>;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t3 || $[12] !== t7 || $[13] !== t9) {
    t10 = <div className={t3} style={t4}>{t7}{t9}</div>;
    $[11] = t3;
    $[12] = t7;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  return t10;
};